import '../scss/parts.scss'

import { importModules } from './common/functions'

// Import all block scripts
const blocks = import.meta.webpackContext('../../blocks', {
  mode: 'eager',
  regExp: /scripts\/_block\.js$/
})

// Execute all imported modules
const initParts = async () => {
  await importModules(blocks)
}

window.addEventListener('DOMContentLoaded', () => {
  initParts()
})
